import React from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
  padding: "0 2rem",

  ".data": {
    color: theme.color.black,
    fontWeight: theme.fontWeight.medium,
  },
}));

const Line = styled.div({
  width: "100%",
  height: "1px",
  backgroundColor: "#cccccc",
});

const Flex = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: "0.4rem",
  alignItems: "center",
}));

const Method = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.6rem",
  paddingBottom: "0.8rem",
}));

type Props = {
  paymentDate: string;
  amount: number;
  methodValue: string;
};
const SubscribeDetailCard = ({ paymentDate, amount, methodValue }: Props) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Flex>
        <span>{t("결제일")}</span>
        <span className="data">{paymentDate}</span>
      </Flex>

      <Flex>
        <span>{t("결제금액")}</span>
        <span className="data">
          월 {amount.toLocaleString()} {t("원")}
        </span>
      </Flex>

      <Method>
        <Flex>
          <span>{t("결제수단")}</span>
          <span className="data">{methodValue}</span>
        </Flex>
      </Method>
      <Line />
    </Container>
  );
};

export default SubscribeDetailCard;
